import Tooltip from './BaseTooltip';

export default Tooltip;
